export default "__VITE_ASSET__160347e2__"